import { motion } from "framer-motion";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import Merchant from "../../Assets/Projects/Merchant-Dashboard.png";
// import AmongUs from "../../Assets/Projects/AmongUs.png";
import lbhmarket from "../../Assets/Projects/lbhmarket.png";
import predicator from "../../Assets/Projects/ai-predicator.png";
import Agent from "../../Assets/Projects/Agent-Dashboard.png";
import LocationPrivacy from "../../Assets/Projects/Location-Privacy.png";
import calgaryTransit from "../../Assets/Projects/calgary-transit.png";

function Projects() {
  const projects = [
    {
      imgPath: predicator,
      title: "Predicator",
      description:
        "Hackathon Winner: Predict failures in a pipeline using AI and machine learning.",
      ghLink: "https://github.com/Benedict-Kpaduwa/AI-Predictor-Dashboard",
      demoLink: "",
    },
    {
      imgPath: lbhmarket,
      title: "LBH Market",
      description:
        "An online ecommerce retail store built using Next.js, Tailwind CSS and Adonis.js with modern shopping cart features, product management, and secure payment integration.",
      ghLink: "",
      demoLink: "https://lbhmarket.com/",
    },
    // {
    //   imgPath: Merchant,
    //   title: "Merchant Dashboard",
    //   description:
    //     "Built a merchant-facing Progressive Web App (PWA) supporting payments, reporting, and outlet management. Developed inventory management features for tracking products, stock levels, and order history.",
    //   demoLink: "https://apeiron-merchants.cyberbyte.com.ng",
    // },
    // {
    //   imgPath: Agent,
    //   title: "Agent Application",
    //   description:
    //     "Built an agent-facing Progressive Web App (PWA) for managing customer accounts, processing payments, and tracking transactions. Developed features for account management, transaction history, and user authentication.",
    //   // ghLink: "https://github.com/Benedict-Kpaduwa/Examine",
    //   demoLink: "https://test-agent-admin.cyberbyte.com.ng/",
    // },
    {
      imgPath: LocationPrivacy,
      title:
        "Location Data Re-identification Risk (UofC Private Data Management Project)",
      description:
        "A location-based privacy-focused application that allows users to analyze their location while maintaining control over their privacy.",
      ghLink: "https://github.com/Benedict-Kpaduwa/Location-Privacy",
      demoLink: "https://location-privacy.benedictk.dev/",
    },
    {
      imgPath: calgaryTransit,
      title: "Calgary Transit",
      description:
        "A modern, interactive web application for tracking Calgary Transit's system in real-time. Built with React.js, FastAPI, and Mapbox GL, featuring 3D visualization, live transit positions, and comprehensive station information..",
      ghLink: "https://github.com/Benedict-Kpaduwa/Transit",
      demoLink: "https://transit.benedictk.dev/",
    },
  ];

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-dark via-dark-light to-dark py-32">
      <Particle />

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
            My Recent <span className="text-gradient">Works</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-300">
            Here are a few projects I've worked on recently.
          </p>
        </motion.div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <ProjectCard {...project} />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Projects;
